"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.StyledFilterGroupLabel = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _ClearFilter = _interopRequireDefault(require("../../icons-react/userflow/ClearFilter"));

var _ArrowDown = _interopRequireDefault(require("../../icons-react/ArrowDown"));

var _Collapsible = _interopRequireDefault(require("../Collapsible"));

var _userflow = require("../../constants/userflow");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var FilterGroup = function FilterGroup(_ref) {
  var label = _ref.label,
      _ref$showClearBtn = _ref.showClearBtn,
      showClearBtn = _ref$showClearBtn === void 0 ? false : _ref$showClearBtn,
      onClear = _ref.onClear,
      children = _ref.children,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$isMobile = _ref.isMobile,
      isMobile = _ref$isMobile === void 0 ? false : _ref$isMobile,
      _ref$isCollapsible = _ref.isCollapsible,
      isCollapsible = _ref$isCollapsible === void 0 ? false : _ref$isCollapsible,
      _ref$isClearButtonInl = _ref.isClearButtonInline,
      isClearButtonInline = _ref$isClearButtonInl === void 0 ? false : _ref$isClearButtonInl;

  var _useState = (0, _react.useState)(!!isCollapsible),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      isCollapsed = _useState2[0],
      setIsCollapsed = _useState2[1];

  var handleClickLabel = function handleClickLabel() {
    return isCollapsible ? setIsCollapsed(!isCollapsed) : null;
  };

  var handleClickClearButton = function handleClickClearButton(e) {
    e.stopPropagation();

    if (onClear) {
      onClear();
    }
  };

  var showInlineClearButton = showClearBtn && isClearButtonInline;
  var showBlockClearButton = showClearBtn && !isClearButtonInline;
  return /*#__PURE__*/_react["default"].createElement(StyledFilterGroup, {
    className: className,
    isMobile: isMobile
  }, /*#__PURE__*/_react["default"].createElement(StyledFilterGroupLabel, {
    isCollapsible: isCollapsible,
    onClick: handleClickLabel
  }, /*#__PURE__*/_react["default"].createElement("span", null, label, showInlineClearButton ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, _userflow.NBSP, /*#__PURE__*/_react["default"].createElement(StyledClearIcon, {
    isInline: true,
    onClick: handleClickClearButton
  })) : null), isCollapsible ? /*#__PURE__*/_react["default"].createElement(StyledDropdownIcon, {
    open: isCollapsed
  }) : null, showBlockClearButton ? /*#__PURE__*/_react["default"].createElement(StyledClearIcon, {
    onClick: onClear
  }) : null), /*#__PURE__*/_react["default"].createElement(_Collapsible["default"], {
    isCollapsed: isCollapsed
  }, children));
};

var StyledFilterGroupLabel = _styledComponents["default"].div.withConfig({
  displayName: "FilterGroup__StyledFilterGroupLabel",
  componentId: "sc-1vw368t-0"
})(["display:flex;justify-content:space-between;align-items:center;margin-bottom:10px;font-weight:bold;font-size:16px;line-height:21px;", ""], function (_ref2) {
  var isCollapsible = _ref2.isCollapsible;
  return isCollapsible && 'cursor: pointer;';
});

exports.StyledFilterGroupLabel = StyledFilterGroupLabel;
var StyledDropdownIcon = (0, _styledComponents["default"])(_ArrowDown["default"]).withConfig({
  displayName: "FilterGroup__StyledDropdownIcon",
  componentId: "sc-1vw368t-1"
})(["width:12px;height:6px;margin-left:5px;margin-bottom:1px;cursor:pointer;transform:rotate(180deg);", " path{fill:#919499;}"], function (_ref3) {
  var open = _ref3.open;
  return !open && "\n    transform: none;\n  ";
});
var StyledClearIcon = (0, _styledComponents["default"])(_ClearFilter["default"]).withConfig({
  displayName: "FilterGroup__StyledClearIcon",
  componentId: "sc-1vw368t-2"
})(["width:16px;height:21px;margin-left:", "px;stroke-width:1px;cursor:pointer;path{stroke:#919499;}", ""], function (_ref4) {
  var isInline = _ref4.isInline;
  return isInline ? 0 : 10;
}, function (_ref5) {
  var isInline = _ref5.isInline;
  return isInline && 'vertical-align: text-top;';
});

var StyledFilterGroup = _styledComponents["default"].div.withConfig({
  displayName: "FilterGroup__StyledFilterGroup",
  componentId: "sc-1vw368t-3"
})(["", ""], function (_ref6) {
  var isMobile = _ref6.isMobile;
  return isMobile && (0, _styledComponents.css)(["", "{font-size:20px;margin-left:10px;margin-right:10px;}", "{width:18px;}"], StyledFilterGroupLabel, StyledClearIcon);
});

var _default = /*#__PURE__*/_react["default"].memo(FilterGroup);

exports["default"] = _default;